import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-421f653a"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "UserInfo_Left" }
const _hoisted_2 = {
  class: "UserInfo_Contents",
  style: {"flex-direction":"column"}
}
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "UserInfo_Contents_Header" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "UserInfo_Contents_Title" }, "ユーザー情報")
], -1))
const _hoisted_4 = { class: "UserInfo_Contents_Main" }
const _hoisted_5 = { class: "UserInfo_Contents_Item" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "ユーザー名", -1))
const _hoisted_7 = { class: "UserInfo_Contents_Item" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "メールアドレス", -1))
const _hoisted_9 = { class: "UserInfo_Contents_Item" }
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "版元コード", -1))
const _hoisted_11 = { class: "UserInfo_Contents_Item" }
const _hoisted_12 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "権限", -1))
const _hoisted_13 = { class: "UserInfo_Contents" }
const _hoisted_14 = {
  key: 0,
  class: "UserInfo_Contents_List"
}
const _hoisted_15 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "UserInfo_Contents_Header" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "UserInfo_Contents_Title" }, "ユーザー名更新")
], -1))
const _hoisted_16 = { class: "UserInfo_Contents_Main" }
const _hoisted_17 = { class: "UserInfo_Contents_Item" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "新しいユーザー名", -1))
const _hoisted_19 = { class: "error_message" }
const _hoisted_20 = { class: "UserInfo_Contents_Item" }
const _hoisted_21 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "新しいユーザー名(確認用)", -1))
const _hoisted_22 = { class: "error_message" }
const _hoisted_23 = {
  key: 1,
  class: "UserInfo_Contents_List"
}
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "UserInfo_Contents_Header" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "UserInfo_Contents_Title" }, "メールアドレス更新")
], -1))
const _hoisted_25 = { class: "UserInfo_Contents_Main" }
const _hoisted_26 = { class: "UserInfo_Contents_Item" }
const _hoisted_27 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "新しいアドレス", -1))
const _hoisted_28 = { class: "error_message" }
const _hoisted_29 = { class: "UserInfo_Contents_Item" }
const _hoisted_30 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "新しいアドレス(確認用)", -1))
const _hoisted_31 = { class: "error_message" }
const _hoisted_32 = { class: "UserInfo_Contents_List" }
const _hoisted_33 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "UserInfo_Contents_Header" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "UserInfo_Contents_Title" }, "パスワード更新")
], -1))
const _hoisted_34 = { class: "UserInfo_Contents_Main" }
const _hoisted_35 = { class: "UserInfo_Contents_Item" }
const _hoisted_36 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "新しいパスワード", -1))
const _hoisted_37 = { class: "error_message" }
const _hoisted_38 = { class: "UserInfo_Contents_Item" }
const _hoisted_39 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, "新しいパスワード(確認用)", -1))
const _hoisted_40 = { class: "error_message" }

import { ref, reactive, computed } from "vue";
import { useStore } from "vuex";
import { useRouter } from "vue-router";
import { Notyf } from "notyf";
import { isValidPassword } from "../functions/Validation.js";
import axios from "axios";
import InputText from "../components/atoms/Input/InputText.vue";
import BtnGreen from "../components/atoms/button/BtnGreen.vue";

type PasswordData = typeof passwordData.value;
type UsernameData = typeof usernameData.value;
type EmailData = typeof emailData.value;

//入力時のデータ更新

export default /*#__PURE__*/_defineComponent({
  __name: 'UserInfo',
  props: {
  isActive_SidebarFlg: { type: Boolean },
},
  emits: ["toggleGlobalHeader", "showGlobalHeader"],
  setup(__props, { emit: __emit }) {

const props = __props;
const store = useStore();
const $router = useRouter();

const emit = __emit;
emit("showGlobalHeader");
const notyf = new Notyf();

//ユーザー情報
const loginUser = store.getters["login/getUserData"];

//入力データ保管用
let passwordData = ref({
  newPassword: "",
  newSubPassword: "",
});
let usernameData = ref({
  newUsername: "",
  newSubUsername: "",
});
let emailData = ref({
  newEmail: "",
  newSubEmail: "",
});
// 型
const passInput = (e: string, key: keyof PasswordData) => {
  passwordData.value[key] = e;
};
const usernameInput = (e: string, key: keyof UsernameData) => {
  usernameData.value[key] = e;
};
const emailInput = (e: string, key: keyof EmailData) => {
  emailData.value[key] = e;
};

let hasErrorPassword = ref(false);
let hasErrorUsername = ref(false);
let hasErrorEmail = ref(false);
let errorMessage = reactive({
  newPassword: "",
  newSubPassword: "",
  newUsername: "",
  newSubUsername: "",
  newEmail: "",
  newSubEmail: "",
});
//ユーザー名の更新処理
const updateUsername = async () => {
  //確認用データが異なっていたら中断
  if (usernameData.value.newUsername !== usernameData.value.newSubUsername) {
    notyf.error("ユーザー名が異なっています");
    return;
  }
  if (
    usernameData.value.newUsername === "" ||
    usernameData.value.newSubUsername === ""
  ) {
    notyf.error("ユーザー名を入力してください");
    return;
  }
  try {
    const res = await axios.patch(
      `${store.getters["getBaseUrl"]}/account/updateUser?username=${usernameData.value.newUsername}&email=`,
      "",
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      }
    );
    // console.log(res);
    if (res.status === 200) {
      usernameData.value.newUsername = "";
      usernameData.value.newSubUsername = "";
      notyf.success(
        "ユーザー名を変更しました。ユーザー情報更新のため再度ログインしてください。"
      );
      store.dispatch("login/logout");
      $router.push("/");
    } else {
      notyf.error("入力されたユーザー名は存在しません。");
    }
  } catch (error) {
    alert("ユーザー名の変更に失敗しました");
    console.log(error);
  }
};
//メールアドレスの更新
const updateEmail = async () => {
  //確認用データが異なっていたら中断
  if (emailData.value.newEmail !== emailData.value.newSubEmail) {
    notyf.error("メールアドレスが異なっています");
    return;
  }
  if (emailData.value.newEmail === "" || emailData.value.newSubEmail === "") {
    notyf.error("メールアドレスを入力してください");
    return;
  }
  // console.log(
  //   `${store.getters["getBaseUrl"]}/account/updateUser?username=&email=${emailData.value.newEmail}`
  // );
  try {
    const res = await axios.patch(
      `${store.getters["getBaseUrl"]}/account/updateUser?username=&email=${emailData.value.newEmail}`,
      "",
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      }
    );
    // console.log(res);
    if (res.status === 200) {
      emailData.value.newEmail = "";
      emailData.value.newSubEmail = "";
      notyf.success(
        "メールアドレスを変更しました。ユーザー情報更新のため再度ログインしてください。"
      );
      store.dispatch("login/logout");
      $router.push("/");
    } else {
      notyf.error("入力されたメールアドレスは存在しません。");
    }
  } catch (error) {
    alert("メールアドレスの変更に失敗しました");
    console.log(error);
  }
};
//パスワードの更新処理
const updatePassword = async () => {
  validateError();
  if (hasErrorPassword.value) {
    return;
  }
  try {
    const res = await axios.patch(
      `${store.getters["getBaseUrl"]}/account/updatePassword?password=${passwordData.value.newPassword}`,
      "",
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
        },
      }
    );
    if (res.data === "OK") {
      passwordData.value.newPassword = "";
      passwordData.value.newSubPassword = "";
      notyf.success("パスワードを変更しました。");
    } else {
      notyf.error(res.data);
    }
  } catch (error) {
    alert("パスワードの変更に失敗しました");
    console.log(error);
  }
};
//バリデーション
const validateError = () => {
  hasErrorPassword.value = false;
  errorMessage.newPassword = "";
  errorMessage.newSubPassword = "";
  hasErrorUsername.value = false;
  if (passwordData.value.newPassword === "") {
    errorMessage.newPassword = "新しいパスワードを入力してください";
    hasErrorPassword.value = true;
  }
  if (passwordData.value.newSubPassword === "") {
    errorMessage.newSubPassword = "新しいパスワード(確認用)を入力してください";
    hasErrorPassword.value = true;
  }
  //パスワードは半角英数字、半角記号(_@-/.)
  if (!isValidPassword(passwordData.value.newPassword)) {
    errorMessage.newPassword =
      "パスワードは半角英数字、半角記号(_@-/.)8～20桁で入力してください";
    hasErrorPassword.value = true;
  }
  if (!isValidPassword(passwordData.value.newSubPassword)) {
    errorMessage.newSubPassword =
      "パスワードは半角英数字、半角記号(_@-/.)8～20桁で入力してください";
    hasErrorPassword.value = true;
  }
  //確認用パスワードが異なっていたら中断
  if (passwordData.value.newPassword !== passwordData.value.newSubPassword) {
    notyf.error("パスワードが異なっています");
    hasErrorPassword.value = true;
  }
};

// 講談社用表示制御
const storeUserData = computed(() => {
  return store.getters["login/getUserData"];
});
const isKodansha = computed(() => {
  return storeUserData.value.hanmotoCd == "2253";
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["UserInfo", {
      SideBar_False: !props.isActive_SidebarFlg,
      SideBar_True: props.isActive_SidebarFlg,
    }])
  }, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _hoisted_3,
        _createElementVNode("div", _hoisted_4, [
          _createElementVNode("div", _hoisted_5, [
            _hoisted_6,
            _createTextVNode(" " + _toDisplayString(_unref(loginUser).username), 1)
          ]),
          _createElementVNode("div", _hoisted_7, [
            _hoisted_8,
            _createTextVNode(" " + _toDisplayString(_unref(loginUser).email), 1)
          ]),
          _createElementVNode("div", _hoisted_9, [
            _hoisted_10,
            _createTextVNode(" " + _toDisplayString(_unref(loginUser).hanmotoCd), 1)
          ]),
          _createElementVNode("div", _hoisted_11, [
            _hoisted_12,
            _createTextVNode(" " + _toDisplayString(_unref(loginUser).role), 1)
          ])
        ])
      ]),
      _createElementVNode("div", _hoisted_13, [
        (!isKodansha.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_14, [
              _hoisted_15,
              _createElementVNode("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _hoisted_18,
                  _createVNode(InputText, {
                    class: "Login_Form_Input",
                    value: _unref(usernameData).newUsername,
                    onOnInput: _cache[0] || (_cache[0] = ($event: any) => (usernameInput($event, 'newUsername')))
                  }, null, 8, ["value"]),
                  _createElementVNode("div", _hoisted_19, _toDisplayString(_unref(errorMessage).newUsername), 1)
                ]),
                _createElementVNode("div", _hoisted_20, [
                  _hoisted_21,
                  _createVNode(InputText, {
                    class: "Login_Form_Input",
                    value: _unref(usernameData).newSubUsername,
                    onOnInput: _cache[1] || (_cache[1] = ($event: any) => (usernameInput($event, 'newSubUsername')))
                  }, null, 8, ["value"]),
                  _createElementVNode("div", _hoisted_22, _toDisplayString(_unref(errorMessage).newSubUsername), 1)
                ]),
                _createVNode(BtnGreen, {
                  class: "Admin_Form_BtnGreen",
                  onClick: updateUsername
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("ユーザー名更新")
                  ]),
                  _: 1
                })
              ])
            ]))
          : _createCommentVNode("", true),
        (!isKodansha.value)
          ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
              _hoisted_24,
              _createElementVNode("div", _hoisted_25, [
                _createElementVNode("div", _hoisted_26, [
                  _hoisted_27,
                  _createVNode(InputText, {
                    class: "Login_Form_Input",
                    value: _unref(emailData).newEmail,
                    onOnInput: _cache[2] || (_cache[2] = ($event: any) => (emailInput($event, 'newEmail')))
                  }, null, 8, ["value"]),
                  _createElementVNode("div", _hoisted_28, _toDisplayString(_unref(errorMessage).newEmail), 1)
                ]),
                _createElementVNode("div", _hoisted_29, [
                  _hoisted_30,
                  _createVNode(InputText, {
                    class: "Login_Form_Input",
                    value: _unref(emailData).newSubEmail,
                    onOnInput: _cache[3] || (_cache[3] = ($event: any) => (emailInput($event, 'newSubEmail')))
                  }, null, 8, ["value"]),
                  _createElementVNode("div", _hoisted_31, _toDisplayString(_unref(errorMessage).newSubEmail), 1)
                ]),
                _createVNode(BtnGreen, {
                  class: "Admin_Form_BtnGreen",
                  onClick: updateEmail
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("アドレス更新")
                  ]),
                  _: 1
                })
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("div", _hoisted_32, [
          _hoisted_33,
          _createElementVNode("div", _hoisted_34, [
            _createElementVNode("div", _hoisted_35, [
              _hoisted_36,
              _createVNode(InputText, {
                class: "Login_Form_Input",
                type: "password",
                value: _unref(passwordData).newPassword,
                onOnInput: _cache[4] || (_cache[4] = ($event: any) => (passInput($event, 'newPassword')))
              }, null, 8, ["value"]),
              _createElementVNode("div", _hoisted_37, _toDisplayString(_unref(errorMessage).newPassword), 1)
            ]),
            _createElementVNode("div", _hoisted_38, [
              _hoisted_39,
              _createVNode(InputText, {
                class: "Login_Form_Input",
                type: "password",
                value: _unref(passwordData).newSubPassword,
                onOnInput: _cache[5] || (_cache[5] = ($event: any) => (passInput($event, 'newSubPassword')))
              }, null, 8, ["value"]),
              _createElementVNode("div", _hoisted_40, _toDisplayString(_unref(errorMessage).newSubPassword), 1)
            ]),
            _createVNode(BtnGreen, {
              class: "Admin_Form_BtnGreen",
              onClick: updatePassword
            }, {
              default: _withCtx(() => [
                _createTextVNode("パスワード更新")
              ]),
              _: 1
            })
          ])
        ])
      ])
    ])
  ], 2))
}
}

})